.section {
  padding: 7rem 2rem;
  background: var(--color-background);
  border-top: 1px solid var(--color-border);
  position: relative;
  overflow: hidden;
}

.container {
  max-width: 1180px;
  margin: 0 auto;
  text-align: center;
  position: relative;
  z-index: 1;
}

.title {
  max-width: 820px;
  margin: 0 auto 1rem;
}

.subtitle {
  max-width: 680px;
  margin: 0 auto 4rem;
}

.plans {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 1rem;
  align-items: flex-start;
}

.plan {
  position: relative;
  height: 100%;
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  text-align: start;
  background: var(--color-card);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  transition:
    border-color 0.2s ease,
    background 0.2s ease;

  &:hover {
    border-color: var(--color-primary-border);
    background: var(--color-surface-raised);
  }

  &.highlighted {
    border-color: var(--color-primary-border);
    background: var(--color-primary-soft);
    box-shadow: var(--shadow-sm);

    &:hover {
      border-color: var(--color-primary);
    }
  }
}

.badge {
  position: absolute;
  top: -14px;
  left: 50%;
  transform: translateX(-50%);
  padding: 0.45rem 1rem;
  background: var(--color-primary);
  color: var(--color-primary-foreground);
  border-radius: 999px;
}

.planHeader {
  padding-bottom: 1.5rem;
  text-align: center;
  border-bottom: 1px solid var(--color-border);
}

.planName {
  margin: 0 0 1rem;
}

.planPrice {
  margin-bottom: 1rem;
  display: flex;
  align-items: baseline;
  justify-content: center;
}

.price {
}

.period {
  margin-inline-start: 0.35rem;
}

.planDescription {
}

.planButton {
  width: 100%;
  padding: 1rem;
  font-size: 1rem;
}

.features {
  flex-grow: 1;
  padding: 0;
  margin: 0;
  list-style: none;
}

.feature {
  display: flex;
  align-items: flex-start;
  gap: 0.85rem;
  padding: 0.75rem 0;
  color: var(--color-muted);
  font-size: 0.95rem;
  line-height: 1.5;

  &:first-child {
    padding-top: 0;
  }
}

.checkIcon {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  margin-top: 0.125rem;
  padding: 2px;
  color: var(--color-secondary);
  background: color-mix(in srgb, var(--color-secondary) 10%, transparent);
  border-radius: 50%;
}

// The unit prices live in the docs: the subtitle ends with the way to them.
.unitPrices {
  display: inline;
}

@media (max-width: 768px) {
  .section {
    padding: 5rem 1.5rem;
  }

  .plans {
    grid-template-columns: 1fr;
  }

  .plan {
    padding: 1.35rem;
  }
}
